/**
 * Funkcinės Terapijos Centras — Simptomų Tikrintuvas
 * Self-injecting widget. One line to embed:
 *
 *   <script src="https://funkcinesterapijoscentras.lt/assets/ftc-checker.js"
 *     data-klaviyo-id="YOUR_COMPANY_ID"
 *     data-list-id="YOUR_LIST_ID"
 *     data-booking-url="https://funkcinesterapijoscentras.lt/pages/registracija">
 *   </script>
 *
 * Or if you want to control placement, add <div id="ftc-symptom-checker"></div>
 * anywhere in your page and the widget will render inside it.
 */
(function () {
  'use strict';

  // ── Read config from script tag ──
  var scriptTag = document.currentScript;
  var KLAVIYO_COMPANY_ID = scriptTag.getAttribute('data-klaviyo-id') || 'WGyTS6';
  var KLAVIYO_LIST_ID = scriptTag.getAttribute('data-list-id') || 'YdXhEZ';
  var BOOKING_URL = scriptTag.getAttribute('data-booking-url') || 'https://funkcinesterapijoscentras.lt/pages/registracija';

  // ── Inject CSS ──
  var css = document.createElement('style');
  css.textContent = '' +
    '.ftc-checker *,.ftc-checker *::before,.ftc-checker *::after{box-sizing:border-box;margin:0;padding:0}' +
    '.ftc-checker{font-family:"Segoe UI",system-ui,-apple-system,sans-serif;max-width:640px;margin:40px auto;border-radius:16px;overflow:hidden;box-shadow:0 8px 32px rgba(30,126,186,.18);background:#fff}' +
    '.ftc-header{background:linear-gradient(135deg,#1E7EBA 0%,#1a6da3 100%);padding:32px 28px 24px;text-align:center;position:relative;overflow:hidden}' +
    '.ftc-header::before{content:"";position:absolute;top:-40%;right:-20%;width:260px;height:260px;background:rgba(0,190,195,.12);border-radius:50%}' +
    '.ftc-header::after{content:"";position:absolute;bottom:-30%;left:-10%;width:180px;height:180px;background:rgba(255,255,255,.06);border-radius:50%}' +
    '.ftc-header h2{color:#fff;font-size:22px;font-weight:700;margin-bottom:6px;position:relative;z-index:1;line-height:1.3}' +
    '.ftc-header p{color:rgba(255,255,255,.85);font-size:14px;position:relative;z-index:1}' +
    '.ftc-badge{display:inline-block;background:rgba(0,190,195,.25);color:#fff;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:1.2px;padding:4px 14px;border-radius:20px;margin-bottom:12px;position:relative;z-index:1}' +
    '.ftc-progress-wrap{padding:0 28px;margin-top:-8px;position:relative;z-index:2}' +
    '.ftc-progress-bar{height:6px;background:#e8f0f5;border-radius:3px;overflow:hidden;margin-top:16px}' +
    '.ftc-progress-fill{height:100%;background:linear-gradient(90deg,#00BEC3,#1E7EBA);border-radius:3px;transition:width .5s cubic-bezier(.4,0,.2,1);width:0%}' +
    '.ftc-step-count{text-align:center;font-size:12px;color:#7a9bb5;margin-top:8px;font-weight:500}' +
    '.ftc-body{padding:24px 28px 28px;min-height:320px;position:relative}' +
    '.ftc-intro{text-align:center}' +
    '.ftc-intro-icon{width:72px;height:72px;background:linear-gradient(135deg,#e6f5f6,#d4eef5);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 20px}' +
    '.ftc-intro-icon svg{width:36px;height:36px;color:#1E7EBA}' +
    '.ftc-intro h3{font-size:18px;color:#1a2e3d;margin-bottom:10px;font-weight:600}' +
    '.ftc-intro p{font-size:14px;color:#5a7080;line-height:1.6;margin-bottom:8px}' +
    '.ftc-intro-list{text-align:left;margin:16px auto;max-width:380px}' +
    '.ftc-intro-list-item{display:flex;align-items:flex-start;gap:10px;padding:8px 0;font-size:13px;color:#3d5a6e}' +
    '.ftc-intro-list-item .ftc-check{width:20px;height:20px;min-width:20px;background:#00BEC3;border-radius:50%;display:flex;align-items:center;justify-content:center;margin-top:1px}' +
    '.ftc-intro-list-item .ftc-check svg{width:12px;height:12px;color:#fff}' +
    '.ftc-slide{display:none;animation:ftcFadeIn .4s ease}' +
    '.ftc-slide.active{display:block}' +
    '@keyframes ftcFadeIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}' +
    '.ftc-question-num{font-size:12px;font-weight:600;color:#00BEC3;text-transform:uppercase;letter-spacing:1px;margin-bottom:8px}' +
    '.ftc-question-text{font-size:17px;color:#1a2e3d;font-weight:600;margin-bottom:6px;line-height:1.4}' +
    '.ftc-question-hint{font-size:13px;color:#7a9bb5;margin-bottom:24px;line-height:1.5}' +
    '.ftc-slider-wrap{padding:12px 0 8px}' +
    '.ftc-slider-labels{display:flex;justify-content:space-between;margin-bottom:12px}' +
    '.ftc-slider-label{font-size:12px;font-weight:500;padding:6px 12px;border-radius:8px;transition:all .3s ease;max-width:45%;text-align:center;line-height:1.3}' +
    '.ftc-slider-label.left{color:#1E7EBA;background:#e8f4fa}' +
    '.ftc-slider-label.right{color:#c46b20;background:#fef3e8}' +
    '.ftc-range-track{position:relative;height:48px;display:flex;align-items:center}' +
    '.ftc-range{-webkit-appearance:none;appearance:none;width:100%;height:8px;border-radius:4px;background:linear-gradient(90deg,#1E7EBA,#e0e8ed 50%,#e8a04c);outline:none;cursor:pointer}' +
    '.ftc-range::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:28px;height:28px;border-radius:50%;background:#fff;border:3px solid #00BEC3;box-shadow:0 2px 8px rgba(0,190,195,.3);cursor:pointer;transition:transform .2s ease,box-shadow .2s ease}' +
    '.ftc-range::-webkit-slider-thumb:hover{transform:scale(1.15);box-shadow:0 3px 14px rgba(0,190,195,.4)}' +
    '.ftc-range::-moz-range-thumb{width:28px;height:28px;border-radius:50%;background:#fff;border:3px solid #00BEC3;box-shadow:0 2px 8px rgba(0,190,195,.3);cursor:pointer}' +
    '.ftc-range-value{text-align:center;margin-top:8px;font-size:13px;font-weight:600;color:#1E7EBA;min-height:20px}' +
    '.ftc-options{display:flex;flex-direction:column;gap:10px;margin-top:4px}' +
    '.ftc-option{display:flex;align-items:center;gap:12px;padding:14px 16px;border:2px solid #e8f0f5;border-radius:12px;cursor:pointer;transition:all .25s ease;background:#fff}' +
    '.ftc-option:hover{border-color:#b8dce8;background:#f6fbfd}' +
    '.ftc-option.selected{border-color:#00BEC3;background:#e6f9fa}' +
    '.ftc-option-radio{width:22px;height:22px;min-width:22px;border-radius:50%;border:2px solid #c8d8e2;display:flex;align-items:center;justify-content:center;transition:all .25s ease}' +
    '.ftc-option.selected .ftc-option-radio{border-color:#00BEC3;background:#00BEC3}' +
    '.ftc-option.selected .ftc-option-radio::after{content:"";width:8px;height:8px;background:#fff;border-radius:50%}' +
    '.ftc-option-text{font-size:14px;color:#2a4050;font-weight:500}' +
    '.ftc-buttons{display:flex;justify-content:space-between;align-items:center;margin-top:28px;gap:12px}' +
    '.ftc-btn{padding:12px 28px;border-radius:10px;font-size:14px;font-weight:600;cursor:pointer;border:none;transition:all .3s ease;display:inline-flex;align-items:center;gap:6px}' +
    '.ftc-btn-primary{background:linear-gradient(135deg,#00BEC3,#00a8ad);color:#fff;box-shadow:0 4px 14px rgba(0,190,195,.3)}' +
    '.ftc-btn-primary:hover{transform:translateY(-1px);box-shadow:0 6px 20px rgba(0,190,195,.4)}' +
    '.ftc-btn-secondary{background:transparent;color:#7a9bb5;border:2px solid #e0e8ed}' +
    '.ftc-btn-secondary:hover{border-color:#b8d0dd;color:#5a7a90}' +
    '.ftc-btn-large{width:100%;justify-content:center;padding:14px 28px;font-size:15px}' +
    '.ftc-btn svg{width:16px;height:16px}' +
    '.ftc-email-gate{text-align:center}' +
    '.ftc-email-gate h3{font-size:18px;color:#1a2e3d;margin-bottom:8px;font-weight:600}' +
    '.ftc-email-gate p{font-size:14px;color:#5a7080;margin-bottom:20px;line-height:1.5}' +
    '.ftc-email-icon{width:64px;height:64px;background:linear-gradient(135deg,#e6f5f6,#d4eef5);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 16px}' +
    '.ftc-email-icon svg{width:30px;height:30px;color:#1E7EBA}' +
    '.ftc-input-wrap{position:relative;margin-bottom:12px}' +
    '.ftc-input{width:100%;padding:14px 16px;border:2px solid #e0e8ed;border-radius:10px;font-size:14px;font-family:inherit;color:#2a4050;outline:none;transition:border-color .3s ease;background:#fff}' +
    '.ftc-input:focus{border-color:#00BEC3}' +
    '.ftc-input::placeholder{color:#a8bcc8}' +
    '.ftc-email-note{font-size:11px;color:#a0b0bb;margin-top:8px}' +
    '.ftc-email-error{color:#e05555;font-size:12px;margin-top:4px;display:none}' +
    '.ftc-results{text-align:center}' +
    '.ftc-result-circle-wrap{position:relative;width:160px;height:160px;margin:0 auto 20px}' +
    '.ftc-result-circle{width:160px;height:160px;border-radius:50%;display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;z-index:1}' +
    '.ftc-result-circle.nerve{background:linear-gradient(135deg,#fff4e6,#ffe8cc);border:3px solid #e8a04c}' +
    '.ftc-result-circle.muscle{background:linear-gradient(135deg,#e6f5fa,#ccebf5);border:3px solid #1E7EBA}' +
    '.ftc-result-circle.mixed{background:linear-gradient(135deg,#e6f5f6,#d4eef5);border:3px solid #00BEC3}' +
    '.ftc-result-type{font-size:13px;font-weight:600;text-transform:uppercase;letter-spacing:1px;margin-bottom:2px}' +
    '.ftc-result-label{font-size:20px;font-weight:700}' +
    '.ftc-result-circle.nerve .ftc-result-type{color:#c46b20}.ftc-result-circle.nerve .ftc-result-label{color:#a35a18}' +
    '.ftc-result-circle.muscle .ftc-result-type{color:#1E7EBA}.ftc-result-circle.muscle .ftc-result-label{color:#165f8a}' +
    '.ftc-result-circle.mixed .ftc-result-type{color:#00959a}.ftc-result-circle.mixed .ftc-result-label{color:#007a7e}' +
    '.ftc-result-text{font-size:15px;color:#2a4050;line-height:1.6;margin-bottom:16px;max-width:480px;margin-left:auto;margin-right:auto}' +
    '.ftc-result-detail{background:#f6f9fb;border-radius:12px;padding:16px 20px;margin-bottom:20px;text-align:left}' +
    '.ftc-result-detail h4{font-size:14px;font-weight:600;color:#1a2e3d;margin-bottom:8px}' +
    '.ftc-result-detail p{font-size:13px;color:#5a7080;line-height:1.5}' +
    '.ftc-result-cta,.ftc-result-cta:visited,.ftc-result-cta:active,.ftc-result-cta:hover{background:linear-gradient(135deg,#1E7EBA,#1a6da3);color:#fff !important;padding:14px 32px;border-radius:10px;font-size:15px;font-weight:600;cursor:pointer;border:none;display:inline-flex;align-items:center;gap:8px;transition:all .3s ease;box-shadow:0 4px 14px rgba(30,126,186,.3);text-decoration:none !important}' +
    '.ftc-result-cta:hover{transform:translateY(-1px);box-shadow:0 6px 20px rgba(30,126,186,.4)}' +
    '.ftc-result-cta svg{width:18px;height:18px}' +
    '.ftc-disclaimer{font-size:11px;color:#a0b0bb;margin-top:16px;line-height:1.4;padding-top:12px;border-top:1px solid #eef2f5}' +
    '@media(max-width:480px){.ftc-checker{margin:16px 8px;border-radius:12px}.ftc-header{padding:24px 20px 18px}.ftc-header h2{font-size:19px}.ftc-body{padding:20px 20px 24px}.ftc-progress-wrap{padding:0 20px}.ftc-slider-label{font-size:11px;padding:4px 8px}.ftc-buttons{flex-direction:column-reverse}.ftc-btn{width:100%;justify-content:center}}';
  document.head.appendChild(css);

  // ── SVG helpers ──
  var svgArrowRight = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6"/></svg>';
  var svgArrowLeft  = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M11 17l-5-5m0 0l5-5m-5 5h12"/></svg>';
  var svgCheck      = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4"/></svg>';
  var svgCheckSmall = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>';
  var svgShield     = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>';
  var svgMail       = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>';
  var svgCalendar   = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>';

  // ── Build HTML ──
  var html = '' +
    '<div class="ftc-header">' +
      '<div class="ftc-badge">Nemokamas testas</div>' +
      '<h2>Nervų ar raumenų skausmas?</h2>' +
      '<p>6 žingsnių savitikros klausimynas</p>' +
    '</div>' +
    '<div class="ftc-progress-wrap" id="ftcProgressWrap" style="display:none;">' +
      '<div class="ftc-progress-bar"><div class="ftc-progress-fill" id="ftcProgressFill"></div></div>' +
      '<div class="ftc-step-count" id="ftcStepCount"></div>' +
    '</div>' +
    '<div class="ftc-body">' +

      // Intro
      '<div class="ftc-slide active" id="ftcIntro"><div class="ftc-intro">' +
        '<div class="ftc-intro-icon">' + svgShield + '</div>' +
        '<h3>Sužinokite savo skausmo tipą</h3>' +
        '<p>Atsakykite į 6 paprastus klausimus ir sužinokite, ar jūsų skausmas labiau susijęs su nervų, ar su raumenų sistema.</p>' +
        '<div class="ftc-intro-list">' +
          '<div class="ftc-intro-list-item"><div class="ftc-check">' + svgCheckSmall + '</div><span>Užtrunka tik 2 minutes</span></div>' +
          '<div class="ftc-intro-list-item"><div class="ftc-check">' + svgCheckSmall + '</div><span>Paremtas klinikiniais vertinimo kriterijais</span></div>' +
          '<div class="ftc-intro-list-item"><div class="ftc-check">' + svgCheckSmall + '</div><span>Gausite asmenines rekomendacijas</span></div>' +
        '</div>' +
        '<button class="ftc-btn ftc-btn-primary ftc-btn-large" id="ftcStartBtn">Pradėti testą ' + svgArrowRight + '</button>' +
      '</div></div>' +

      // Q1
      '<div class="ftc-slide" id="ftcQ1">' +
        '<div class="ftc-question-num">1 klausimas iš 6</div>' +
        '<div class="ftc-question-text">Kokio pobūdžio skausmą jaučiate?</div>' +
        '<div class="ftc-question-hint">Pasirinkite, kuris apibūdinimas labiau atitinka jūsų pojūčius.</div>' +
        '<div class="ftc-slider-wrap"><div class="ftc-slider-labels"><span class="ftc-slider-label left">Bukas, maudžiantis, spaudžiantis</span><span class="ftc-slider-label right">Aštrus, duriantis, deginantis</span></div>' +
        '<div class="ftc-range-track"><input type="range" class="ftc-range" id="ftcR1" min="0" max="100" value="50"></div>' +
        '<div class="ftc-range-value" id="ftcV1"></div></div>' +
      '</div>' +

      // Q2
      '<div class="ftc-slide" id="ftcQ2">' +
        '<div class="ftc-question-num">2 klausimas iš 6</div>' +
        '<div class="ftc-question-text">Kaip skausmas pasiskirstęs?</div>' +
        '<div class="ftc-question-hint">Ar skausmas lieka vienoje vietoje, ar plinta toliau?</div>' +
        '<div class="ftc-slider-wrap"><div class="ftc-slider-labels"><span class="ftc-slider-label left">Lokalizuotas vienoje vietoje</span><span class="ftc-slider-label right">Plinta į koją, ranką ar kitur</span></div>' +
        '<div class="ftc-range-track"><input type="range" class="ftc-range" id="ftcR2" min="0" max="100" value="50"></div>' +
        '<div class="ftc-range-value" id="ftcV2"></div></div>' +
      '</div>' +

      // Q3
      '<div class="ftc-slide" id="ftcQ3">' +
        '<div class="ftc-question-num">3 klausimas iš 6</div>' +
        '<div class="ftc-question-text">Ar jaučiate tirpimą arba dilgčiojimą?</div>' +
        '<div class="ftc-question-hint">Tirpimas, \u201Eskruzdėliavimas\u201C ar jautrumas gali rodyti nervų pažeidimą.</div>' +
        '<div class="ftc-options" id="ftcO3">' +
          '<div class="ftc-option" data-val="10"><div class="ftc-option-radio"></div><div class="ftc-option-text">Ne, niekada nejaučiu</div></div>' +
          '<div class="ftc-option" data-val="40"><div class="ftc-option-radio"></div><div class="ftc-option-text">Retkarčiais, trumpam</div></div>' +
          '<div class="ftc-option" data-val="70"><div class="ftc-option-radio"></div><div class="ftc-option-text">Dažnai, ypač tam tikrose padėtyse</div></div>' +
          '<div class="ftc-option" data-val="95"><div class="ftc-option-radio"></div><div class="ftc-option-text">Nuolat arba beveik nuolat</div></div>' +
        '</div>' +
      '</div>' +

      // Q4
      '<div class="ftc-slide" id="ftcQ4">' +
        '<div class="ftc-question-num">4 klausimas iš 6</div>' +
        '<div class="ftc-question-text">Kas labiausiai provokuoja skausmą?</div>' +
        '<div class="ftc-question-hint">Pagalvokite, kokiose situacijose skausmas sustiprėja.</div>' +
        '<div class="ftc-slider-wrap"><div class="ftc-slider-labels"><span class="ftc-slider-label left">Fizinis krūvis ir judesiai</span><span class="ftc-slider-label right">Ilgas sėdėjimas, stovėjimas ar padėtis</span></div>' +
        '<div class="ftc-range-track"><input type="range" class="ftc-range" id="ftcR4" min="0" max="100" value="50"></div>' +
        '<div class="ftc-range-value" id="ftcV4"></div></div>' +
      '</div>' +

      // Q5
      '<div class="ftc-slide" id="ftcQ5">' +
        '<div class="ftc-question-num">5 klausimas iš 6</div>' +
        '<div class="ftc-question-text">Kada skausmas stipriausias?</div>' +
        '<div class="ftc-question-hint">Raumenų skausmas dažniau pasireiškia judant, nervų — ramybėje.</div>' +
        '<div class="ftc-slider-wrap"><div class="ftc-slider-labels"><span class="ftc-slider-label left">Judant ar sportuojant</span><span class="ftc-slider-label right">Ramybėje arba naktį</span></div>' +
        '<div class="ftc-range-track"><input type="range" class="ftc-range" id="ftcR5" min="0" max="100" value="50"></div>' +
        '<div class="ftc-range-value" id="ftcV5"></div></div>' +
      '</div>' +

      // Q6
      '<div class="ftc-slide" id="ftcQ6">' +
        '<div class="ftc-question-num">6 klausimas iš 6</div>' +
        '<div class="ftc-question-text">Kaip tempimo pratimai veikia skausmą?</div>' +
        '<div class="ftc-question-hint">Raumenų skausmą tempimas dažniausiai palengvina, o nervų — gali pabloginti.</div>' +
        '<div class="ftc-options" id="ftcO6">' +
          '<div class="ftc-option" data-val="10"><div class="ftc-option-radio"></div><div class="ftc-option-text">Tempimas aiškiai palengvina</div></div>' +
          '<div class="ftc-option" data-val="35"><div class="ftc-option-radio"></div><div class="ftc-option-text">Kartais padeda, kartais ne</div></div>' +
          '<div class="ftc-option" data-val="65"><div class="ftc-option-radio"></div><div class="ftc-option-text">Neturi jokio poveikio</div></div>' +
          '<div class="ftc-option" data-val="90"><div class="ftc-option-radio"></div><div class="ftc-option-text">Tempimas pablogina skausmą</div></div>' +
        '</div>' +
      '</div>' +

      // Email gate
      '<div class="ftc-slide" id="ftcEmail"><div class="ftc-email-gate">' +
        '<div class="ftc-email-icon">' + svgMail + '</div>' +
        '<h3>Jūsų rezultatai paruošti!</h3>' +
        '<p>Įveskite savo el. paštą ir gaukite detalią analizę bei asmenines rekomendacijas tiesiai į pašto dėžutę.</p>' +
        '<div class="ftc-input-wrap"><input type="email" class="ftc-input" id="ftcEmailInput" placeholder="jūsų@elpaštas.lt"><div class="ftc-email-error" id="ftcEmailError">Įveskite teisingą el. pašto adresą</div></div>' +
        '<button class="ftc-btn ftc-btn-primary ftc-btn-large" id="ftcEmailBtn">Gauti rezultatus ' + svgCheck + '</button>' +
        '<div class="ftc-email-note">Galėsite bet kada atsisakyti naujienlaiškio.</div>' +
      '</div></div>' +

      // Results
      '<div class="ftc-slide" id="ftcResults"><div class="ftc-results">' +
        '<div class="ftc-result-circle-wrap"><div class="ftc-result-circle" id="ftcResultCircle"><div class="ftc-result-type" id="ftcResultType"></div><div class="ftc-result-label" id="ftcResultLabel"></div></div></div>' +
        '<div class="ftc-result-text" id="ftcResultText"></div>' +
        '<div class="ftc-result-detail" id="ftcResultDetail"><h4 id="ftcDetailTitle"></h4><p id="ftcDetailText"></p></div>' +
        '<a class="ftc-result-cta" href="' + BOOKING_URL + '" target="_blank" id="ftcBookingBtn">Registruotis konsultacijai ' + svgCalendar + '</a>' +
        '<div class="ftc-disclaimer">Šis klausimynas yra informacinio pobūdžio ir nepakeičia profesionalaus gydytojo ar kineziterapeuto konsultacijos. Visada kreipkitės į specialistą dėl tikslios diagnozės.</div>' +
      '</div></div>' +

      // Nav buttons
      '<div class="ftc-buttons" id="ftcNav" style="display:none;">' +
        '<button class="ftc-btn ftc-btn-secondary" id="ftcBtnBack">' + svgArrowLeft + ' Atgal</button>' +
        '<button class="ftc-btn ftc-btn-primary" id="ftcBtnNext">Kitas ' + svgArrowRight + '</button>' +
      '</div>' +

    '</div>'; // close .ftc-body

  // ── Mount ──
  var target = document.getElementById('ftc-symptom-checker');
  if (!target) return;
  var root = document.createElement('div');
  root.className = 'ftc-checker';
  root.id = 'ftcChecker';
  root.innerHTML = html;
  target.appendChild(root);

  // ── State ──
  var currentStep = 0;
  var answers = { 1: 50, 2: 50, 3: null, 4: 50, 5: 50, 6: null };
  var totalSteps = 6;

  // ── DOM refs ──
  var nav         = document.getElementById('ftcNav');
  var progressWrap= document.getElementById('ftcProgressWrap');
  var backBtn     = document.getElementById('ftcBtnBack');
  var nextBtn     = document.getElementById('ftcBtnNext');
  var progressFill= document.getElementById('ftcProgressFill');
  var stepCount   = document.getElementById('ftcStepCount');

  // ── Event listeners ──
  document.getElementById('ftcStartBtn').addEventListener('click', function() {
    currentStep = 1; showStep();
  });
  nextBtn.addEventListener('click', function() {
    // Only used for slider steps
    currentStep = currentStep < totalSteps ? currentStep + 1 : 7;
    showStep();
  });
  backBtn.addEventListener('click', function() {
    currentStep = currentStep === 7 ? totalSteps : Math.max(1, currentStep - 1);
    showStep();
  });
  document.getElementById('ftcEmailBtn').addEventListener('click', submitEmail);

  // Sliders
  [1, 2, 4, 5].forEach(function(q) {
    document.getElementById('ftcR' + q).addEventListener('input', function() { updateVal(q); });
  });

  // Option cards (auto-advance)
  [3, 6].forEach(function(q) {
    document.querySelectorAll('#ftcO' + q + ' .ftc-option').forEach(function(el) {
      el.addEventListener('click', function() {
        answers[q] = parseInt(el.getAttribute('data-val'));
        el.parentElement.querySelectorAll('.ftc-option').forEach(function(s) { s.classList.remove('selected'); });
        el.classList.add('selected');
        // Auto-advance after brief visual feedback
        setTimeout(function() {
          currentStep = q < totalSteps ? q + 1 : 7;
          showStep();
        }, 350);
      });
    });
  });

  // ── Functions ──
  function updateVal(q) {
    var slider = document.getElementById('ftcR' + q);
    answers[q] = parseInt(slider.value);
    var valEl = document.getElementById('ftcV' + q);
    var val = answers[q];
    if (val < 30) valEl.textContent = 'Labiau raumenų pusėje';
    else if (val < 50) valEl.textContent = 'Šiek tiek raumenų pusėje';
    else if (val === 50) valEl.textContent = 'Vidurys';
    else if (val < 70) valEl.textContent = 'Šiek tiek nervų pusėje';
    else valEl.textContent = 'Labiau nervų pusėje';
  }

  function calcScore() {
    var sum = 0;
    for (var i = 1; i <= 6; i++) { sum += (answers[i] === null ? 50 : answers[i]); }
    return Math.round(sum / 6);
  }

  function submitEmail() {
    var emailInput = document.getElementById('ftcEmailInput');
    var email = emailInput.value.trim();
    var errorEl = document.getElementById('ftcEmailError');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.style.display = 'block';
      emailInput.style.borderColor = '#e05555';
      return;
    }
    errorEl.style.display = 'none';
    emailInput.style.borderColor = '#00BEC3';
    sendToKlaviyo(email);
    currentStep = 8;
    showStep();
    computeResults();
  }

  function sendToKlaviyo(email) {
    if (!KLAVIYO_COMPANY_ID || !KLAVIYO_LIST_ID) {
      console.warn('[FTC Checker] Klaviyo not configured.');
      return;
    }
    var score = calcScore();
    var resultType = score > 60 ? 'nerve' : (score < 40 ? 'muscle' : 'mixed');

    // Step 1: Subscribe to list with explicit email marketing consent
    var subData = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Symptom Checker Widget',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email },
              subscriptions: {
                email: {
                  marketing: { consent: 'SUBSCRIBED' }
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
        }
      }
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(subData)
    }).then(function(r) {
      console.log('[FTC Checker] Klaviyo subscribe:', r.status);
      if (!r.ok) return r.text().then(function(b) { console.error('[FTC Checker] Subscribe error:', b); });
    }).catch(function(e) {
      console.error('[FTC Checker] Subscribe fetch error:', e);
    });
var subData2={data:{type:'subscription',attributes:{custom_source:'Symptom Checker Widget',profile:{data:{type:'profile',attributes:{email:email},subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}},relationships:{list:{data:{type:'list',id:'VfJCJm'}}}}};
fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+KLAVIYO_COMPANY_ID,{method:'POST',headers:{'Content-Type':'application/json','revision':'2024-10-15'},body:JSON.stringify(subData2)}).then(function(r){console.log('[FTC] combined:',r.status);}).catch(function(e){console.error(e);});
    // Step 2: Set custom profile properties (separate call required by Klaviyo)
    resultType = {nerve:'Nervų kilmės skausmas',muscle:'Raumenų kilmės skausmas',mixed:'Mišrus skausmas'}[resultType] || resultType;
    var profileData = {
      data: {
        type: 'profile',
        attributes: {
          email: email,
          properties: {
            symptom_checker_score: score,
            symptom_checker_result: resultType,
            symptom_checker_date: new Date().toISOString()
          }
        }
      }
    };
    fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(profileData)
    }).then(function(r) {
      console.log('[FTC Checker] Klaviyo profile:', r.status);
      if (!r.ok) return r.text().then(function(b) { console.error('[FTC Checker] Profile error:', b); });
    }).catch(function(e) {
      console.error('[FTC Checker] Profile fetch error:', e);
    });
  }

  function computeResults() {
    var score = calcScore();
    var circle = document.getElementById('ftcResultCircle');
    var typeEl = document.getElementById('ftcResultType');
    var labelEl = document.getElementById('ftcResultLabel');
    var textEl = document.getElementById('ftcResultText');
    var dTitle = document.getElementById('ftcDetailTitle');
    var dText = document.getElementById('ftcDetailText');
    circle.className = 'ftc-result-circle';
    if (score > 60) {
      circle.classList.add('nerve');
      typeEl.textContent = 'Tikėtina'; labelEl.textContent = 'Nervų kilmės';
      textEl.textContent = 'Jūsų atsakymai rodo, kad skausmas gali būti susijęs su nervų dirglumu ar suspaudimu. Tai dažnai pasireiškia kaip radikulopatija, nervų suspaudimas ar neuropatija.';
      dTitle.textContent = 'Ką tai reiškia?';
      dText.textContent = 'Nervų kilmės skausmas dažnai plinta į galūnes, yra lydimas tirpimo ar dilgčiojimo. Svarbu kuo greičiau kreiptis į specialistą, nes anksti pradėta funkcinė terapija gali žymiai pagerinti rezultatus ir užkirsti kelią lėtiniam skausmui.';
    } else if (score < 40) {
      circle.classList.add('muscle');
      typeEl.textContent = 'Tikėtina'; labelEl.textContent = 'Raumenų kilmės';
      textEl.textContent = 'Jūsų atsakymai rodo, kad skausmas labiau susijęs su raumenų įtampa, trigeriniais taškais ar miofascialine disfunkcija. Tai gera žinia — raumenų skausmas paprastai gerai reaguoja į kineziterapiją.';
      dTitle.textContent = 'Ką tai reiškia?';
      dText.textContent = 'Raumenų kilmės skausmas dažnai būna susijęs su perkrova, stresu ar netaisyklinga laikysena. Individuali kineziterapijos programa gali padėti atpalaiduoti įtemptus raumenis, sustiprinti silpnas vietas ir užkirsti kelią skausmo pasikartojimui.';
    } else {
      circle.classList.add('mixed');
      typeEl.textContent = 'Galimai'; labelEl.textContent = 'Mišri kilmė';
      textEl.textContent = 'Jūsų atsakymai rodo, kad skausmas gali būti susijęs tiek su raumenų, tiek su nervų sistema. Tokiais atvejais ypač svarbi profesionali diagnostika.';
      dTitle.textContent = 'Kodėl verta kreiptis?';
      dText.textContent = 'Mišraus skausmo atveju būtina tiksli diagnostika, kad būtų galima nustatyti pirminę priežastį. Mūsų kineziterapeutai atliks išsamų funkcinį įvertinimą ir parengs individualią gydymo programą, pritaikytą būtent jūsų situacijai.';
    }
  }

  function showStep() {
    var slides = document.querySelectorAll('#ftcChecker .ftc-slide');
    slides.forEach(function(s) { s.classList.remove('active'); });

    if (currentStep === 0) {
      document.getElementById('ftcIntro').classList.add('active');
      nav.style.display = 'none'; progressWrap.style.display = 'none';
    } else if (currentStep >= 1 && currentStep <= totalSteps) {
      document.getElementById('ftcQ' + currentStep).classList.add('active');
      progressWrap.style.display = 'block';
      progressFill.style.width = Math.round((currentStep / totalSteps) * 100) + '%';
      stepCount.textContent = currentStep + ' iš ' + totalSteps + ' klausimų';
      // Option steps (Q3, Q6): auto-advance, hide Next; Slider steps: show Next
      if (currentStep === 3 || currentStep === 6) {
        nav.style.display = currentStep === 1 ? 'none' : 'flex';
        nextBtn.style.display = 'none';
        backBtn.style.visibility = 'visible';
      } else {
        nav.style.display = 'flex';
        nextBtn.style.display = '';
        backBtn.style.visibility = currentStep === 1 ? 'hidden' : 'visible';
        nextBtn.innerHTML = currentStep === totalSteps
          ? 'Gauti rezultatus ' + svgCheck
          : 'Kitas ' + svgArrowRight;
        updateVal(currentStep);
      }
    } else if (currentStep === 7) {
      document.getElementById('ftcEmail').classList.add('active');
      nav.style.display = 'flex'; progressWrap.style.display = 'block';
      progressFill.style.width = '100%';
      stepCount.textContent = 'Paskutinis žingsnis';
      backBtn.style.visibility = 'visible';
      nextBtn.style.display = 'none';
    } else if (currentStep === 8) {
      document.getElementById('ftcResults').classList.add('active');
      nav.style.display = 'none'; progressWrap.style.display = 'none';
    }
  }

})();